var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.817383,
    width: 22.7504,
    height: 23.1827,
    rx: 5,
    fill: "#6564DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57211 11.3657C7.59117 11.1237 7.69902 10.8978 7.87416 10.7331C8.0493 10.5684 8.27888 10.477 8.5172 10.4771H14.2323C14.4706 10.477 14.7002 10.5684 14.8753 10.7331C15.0505 10.8978 15.1583 11.1237 15.1774 11.3657L15.558 16.1954C15.5684 16.3284 15.5518 16.462 15.5091 16.5881C15.4663 16.7141 15.3985 16.8298 15.3097 16.9277C15.221 17.0257 15.1133 17.104 14.9935 17.1575C14.8736 17.211 14.7442 17.2386 14.6133 17.2387H8.13613C8.00528 17.2386 7.87585 17.211 7.756 17.1575C7.63615 17.104 7.52846 17.0257 7.43973 16.9277C7.351 16.8298 7.28313 16.7141 7.24041 16.5881C7.1977 16.462 7.18105 16.3284 7.19151 16.1954L7.57211 11.3657V11.3657Z",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2702 11.9259V9.51099C13.2702 8.99862 13.0705 8.50724 12.715 8.14494C12.3594 7.78264 11.8772 7.5791 11.3744 7.5791C10.8716 7.5791 10.3893 7.78264 10.0338 8.14494C9.67826 8.50724 9.47852 8.99862 9.47852 9.51099V11.9259",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop_icon.fa48885fd332d2e83c287cae539d60d0.svg";
export { ForwardRef as ReactComponent };